import React from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";

export default function Navbar() {
  
  return (
    <>
      {/* <nav className="cbp-spmenu cbp-spmenu-vertical cbp-spmenu-left">
        <h3>Webset Digital</h3>

        <div className="apnd-menu-device">
          <a className="popup-open" href="javascript:;" title="">
            <i className="fa fa-pencil-square-o" aria-hidden="true"></i> Request
            a Quote
          </a>
        </div>
      </nav>
      <span className="mobile-nav-btn">
        <a
          href="#"
          className="toggle-menu menu-left push-body jPushMenuBtn"
        ></a>
      </span> */}

      <header className="main_header">

<nav class="navbar navbar-static-top navbar-inverse">
  <div class="container">
    <div class="navbar-header">
      <button class="navbar-toggle" type="button" data-toggle="collapse" data-target=".navbarSupportedContent">    
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>   
      </button>
              <div className="logo">
                <Link to="/">
                  <img src="images/webions_logo_trans.png" alt="" />
                </Link>
              </div>
    </div>
    <div class="collapse navbar-collapse navbarSupportedContent">
    <div className="topnavs">
                  <div className="livchat-divs montfont">
                    <div className="liveChat">
                      <h4>Phone:</h4>
                      <Link to="tel:+442032898634" title="">
                        <i className="fa fa-phone" aria-hidden="true"></i>+44 20
                        3289 8634
                      </Link>
                    </div>
                  </div>
                  <div className="btn-radius-top">
                    <a className="popup-open">
                      <i
                        className="fa fa-pencil-square-o"
                        aria-hidden="true"
                      ></i>{""}
                      Request a Quote
                    </a>
                  </div>
                </div>
      <div className="main-nav">
      <ul class="nav navbar-nav navbar-right montfont">
      <li className="parenturl home">
                      <Link to="/" title="">
                        <img src="images/home.png" alt="" />
                      </Link>
                    </li>
                    <li className="parenturl dropparent">
                      <Link to="/Main_logo" title="">
                        Logo
                        <i
                          className="fa fa-angle-down fa-6"
                          aria-hidden="true"
                        ></i>
                      </Link>
                      <div className="dropdown">
                        <div className="lstnavig">
                          <ul className="liststylss">
                            <li className="always-active active">
                              <Link to="/Main_logo" title="">
                                <i className="sprite iconlogo-design"></i>
                                <span>Logo Design</span>
                              </Link>
                              <div className="innerdropdowns active-permenent">
                                <div className="listdiscret">
                                  <p>
                                    Get an outstanding logo to advertise your
                                    brand extensively.{" "}
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Iconic{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Animated{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Typographic{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Illustrative{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img
                                    src="images/navgition-rightimg.jpg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="pricing"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}
                              >
                                <i className="sprite iconlogo-pack"></i>
                                <span>Logo Packages</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    No matter what you're looking for in Logo
                                    Design Services, we have a package that's
                                    right for you.{" "}
                                  </p>
                                  <a
                                    className="btnstarts startspackfr"
                                    href="javascript:;"
                                    title=""
                                  >
                                    Starting from
                                    <span className="montfont">£59</span>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img
                                    src="images/navgition-rightimg.jpg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="porfolio"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-port"></i>
                                <span>Logo Portfolio</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    We enrich the most prestigious names as our
                                    satisfied clientele.{" "}
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Photography{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Fashion{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        E-Commerce{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Real Estate{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Security{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Fitness{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img
                                    src="images/navgition-rightimg.jpg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </li>
                            <li>
                              <Link to="/Review" title="">
                                <i className="sprite iconlogo-review"></i>
                                <span>Reviews</span>
                              </Link>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Read the immense appreciation we receive
                                    from our customers.{" "}
                                  </p>
                                  <a className="btnstarts" href="#" title="">
                                    Read Client Reviews
                                    <i
                                      className="fa fa-caret-right"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img
                                    src="images/navgition-rightimg.jpg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="parenturl dropparent">
                      <Link to="/website" title="">
                        Website
                        <i
                          className="fa fa-angle-down fa-6"
                          aria-hidden="true"
                        ></i>
                      </Link>
                      <div className="dropdown">
                        <div className="lstnavig">
                          <ul className="liststylss">
                            <li className="always-active active">
                              <Link to="/Website" title="">
                                <i className="sprite iconlogo-design"></i>
                                <span>Web Development</span>
                              </Link>
                              <div className="innerdropdowns active-permenent">
                                <div className="listdiscret">
                                  <p>
                                    Get an amazing website to extend your brand
                                    reach.{" "}
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Static{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        E-Commerce{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        B2B and B2C Portals{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        CMS{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-web.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="web_pricing"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-pack"></i>
                                <span>Website Packages</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    No matter what you're looking for in a web
                                    design, we have a package that's right for
                                    you.
                                  </p>
                                  <a
                                    className="btnstarts startspackfr"
                                    href="javascript:;"
                                    title=""
                                  >
                                    Starting from
                                    <span className="montfont">£399</span>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-web.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="web_portfolio"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-port"></i>
                                <span>Website Portfolio</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    We enrich the most prestigious names as our
                                    satisfied clientele.
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Photography{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Fashion{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Information & Technology
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        E-Commerce{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-web.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <Link to="/Review" title="">
                                <i className="sprite iconlogo-review"></i>
                                <span>Reviews</span>
                              </Link>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Read the immense appreciation we receive
                                    from our customers.
                                  </p>
                                  <a className="btnstarts" href="#" title="">
                                    Read Client Reviews
                                    <i
                                      className="fa fa-caret-right"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-web.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="parenturl">
                      <Link to="/Nft_design">NFT-Design </Link>
                    </li>
                    <li className="parenturl dropparent">
                      <Link to="/animation_design" title="">
                        Animation
                        <i
                          className="fa fa-angle-down fa-6"
                          aria-hidden="true"
                        ></i>
                      </Link>
                      <div className="dropdown">
                        <div className="lstnavig">
                          <ul className="liststylss anim-drop">
                            <li className="always-active active">
                              <Link to="/Animation_design">
                                <i className="sprite iconlogo-design"></i>
                                <span>Animation Design</span>
                              </Link>
                              <div className="innerdropdowns active-permenent">
                                <div className="listdiscret">
                                  <p>
                                    Get an interactive animated video for your
                                    brand.
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a href="#" title="">
                                        2D Character Animation
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        2D Graphic Animation{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Interactive 3D Animation{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Whiteboard Animation
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Typographic Animation
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Explainer <br />
                                        Videos
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-animation.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="animation_pricing"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-pack"></i>
                                <span>Animation Packages</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    No matter what you're looking for in an
                                    animated video, we have a package that's
                                    right for you.
                                  </p>
                                  <a
                                    className="btnstarts startspackfr"
                                    href="#"
                                    title=""
                                  >
                                    Starting from
                                    <span className="montfont">£499</span>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-animation.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="animdropsPort"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-port"></i>
                                <span>Animation Portfolio</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    We enrich the most prestigious names as our
                                    satisfied clientele.
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Photography{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Fashion{" "}
                                      </a>
                                    </li>

                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Information & Technology
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        E-Commerce{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-animation.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <Link to="/Review">
                                <i className="sprite iconlogo-review"></i>
                                <span>Reviews</span>
                              </Link>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Read the immense appreciation we receive
                                    from our customers.
                                  </p>
                                  <a className="btnstarts" href="#" title="">
                                    Read Client Reviews
                                    <i
                                      className="fa fa-caret-right"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-animation.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="parenturl dropparent">
                      <Link to="/Branding_design" title="">
                        Branding
                        <i
                          className="fa fa-angle-down fa-6"
                          aria-hidden="true"
                        ></i>
                      </Link>
                      <div className="dropdown">
                        <div className="lstnavig">
                          <ul className="liststylss">
                            <li className="always-active active">
                              <Link to="/Branding_design">
                                <i className="sprite iconlogo-design"></i>
                                <span>Branding Design</span>
                              </Link>
                              <div className="innerdropdowns active-permenent">
                                <div className="listdiscret">
                                  <p>
                                    Get complete branding solutions for your
                                    brand.
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a href="#" title="">
                                        Brochures{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Banners{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Stationery{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Packaging{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-branding.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="packdropsbrand"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-pack"></i>
                                <span>Branding Packages</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    No matter what you're looking for in Logo
                                    Design Services, we have a package that's
                                    right for you.{" "}
                                  </p>
                                  <a
                                    className="btnstarts startspackfr"
                                    href="#"
                                    title=""
                                  >
                                    Starting from
                                    <span className="montfont">£249</span>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-branding.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="branding_portfolio"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-port"></i>
                                <span>Branding Portfolio</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Exclusive brochures for enhanced
                                    advertising.{" "}
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Leaflet{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Bifold{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Trifold{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-branding.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <Link to="/Review">
                                <i className="sprite iconlogo-review"></i>
                                <span>Reviews</span>
                              </Link>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Read the immense appreciation we receive
                                    from our customers.
                                  </p>
                                  <a className="btnstarts" href="#" title="">
                                    Read Client Reviews
                                    <i
                                      className="fa fa-caret-right"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-branding.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="parenturl">
                      <Link to="/Packages" title="">
                        Packages
                      </Link>
                    </li>
                    <li className="parenturl">
                      <Link to="/Portfoli" title="">
                        Portfolio
                      </Link>
                    </li>
                    <li className="parenturl">
                      <Link to="/About">About Us </Link>
                    </li>
                    <li className="parenturl">
                      <Link to="/Contact_main" title="">
                        Contact Us
                      </Link>
                    </li>
    </ul>
      </div>
    </div>
  </div>
</nav>
      </header>
      {/* <header>
        <div className="container">
          <div className="row">
            <div className="col-lg-2 col-md-2 col-sm-12">
              <div className="logo">
                <Link to="/">
                  <img src="images/webions_logo_trans.png" alt="" />
                </Link>
              </div>
            </div>
            <div className="col-lg-10 col-md-10 col-sm-12 lg-hidden ">
              <div className="fright">
                <div className="topnavs">
                  <div className="livchat-divs montfont">
                    <div className="liveChat">
                      <h4>Phone:</h4>
                      <a href="tel:+442032898634" title="">
                        <i className="fa fa-phone" aria-hidden="true"></i>+44 20
                        3289 8634
                      </a>
                    </div>
                  </div>
                  <div className="btn-radius-top">
                    <a className="popup-open" href="#" title="">
                      <i
                        className="fa fa-pencil-square-o"
                        aria-hidden="true"
                      ></i>{" "}
                      Request a Quote
                    </a>
                  </div>
                </div>
                <div className="main-nav">
                  <ul className="montfont">
                    <li className="parenturl home">
                      <Link to="/" title="">
                        <img src="images/home.png" alt="" />
                      </Link>
                    </li>
                    <li className="parenturl dropparent">
                      <Link to="/" title="">
                        Logo
                        <i
                          className="fa fa-angle-down fa-6"
                          aria-hidden="true"
                        ></i>
                      </Link>
                      <div className="dropdown">
                        <div className="lstnavig">
                          <ul className="liststylss">
                            <li className="always-active active">
                              <Link to="/Main_logo" title="">
                                <i className="sprite iconlogo-design"></i>
                                <span>Logo Design</span>
                              </Link>
                              <div className="innerdropdowns active-permenent">
                                <div className="listdiscret">
                                  <p>
                                    Get an outstanding logo to advertise your
                                    brand extensively.{" "}
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Iconic{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Animated{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Typographic{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Illustrative{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img
                                    src="images/navgition-rightimg.jpg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="pricing"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}
                              >
                                <i className="sprite iconlogo-pack"></i>
                                <span>Logo Packages</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    No matter what you're looking for in Logo
                                    Design Services, we have a package that's
                                    right for you.{" "}
                                  </p>
                                  <a
                                    className="btnstarts startspackfr"
                                    href="javascript:;"
                                    title=""
                                  >
                                    Starting from
                                    <span className="montfont">£59</span>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img
                                    src="images/navgition-rightimg.jpg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="porfolio"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-port"></i>
                                <span>Logo Portfolio</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    We enrich the most prestigious names as our
                                    satisfied clientele.{" "}
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Photography{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Fashion{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        E-Commerce{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Real Estate{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Security{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Fitness{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img
                                    src="images/navgition-rightimg.jpg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </li>
                            <li>
                              <Link to="/Review" title="">
                                <i className="sprite iconlogo-review"></i>
                                <span>Reviews</span>
                              </Link>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Read the immense appreciation we receive
                                    from our customers.{" "}
                                  </p>
                                  <a className="btnstarts" href="#" title="">
                                    Read Client Reviews
                                    <i
                                      className="fa fa-caret-right"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img
                                    src="images/navgition-rightimg.jpg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="parenturl dropparent">
                      <a href="#" title="">
                        Website
                        <i
                          className="fa fa-angle-down fa-6"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <div className="dropdown">
                        <div className="lstnavig">
                          <ul className="liststylss">
                            <li className="always-active active">
                              <Link to="/Website" title="">
                                <i className="sprite iconlogo-design"></i>
                                <span>Web Development</span>
                              </Link>
                              <div className="innerdropdowns active-permenent">
                                <div className="listdiscret">
                                  <p>
                                    Get an amazing website to extend your brand
                                    reach.{" "}
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Static{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        E-Commerce{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        B2B and B2C Portals{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        CMS{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-web.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="web_pricing"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-pack"></i>
                                <span>Website Packages</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    No matter what you're looking for in a web
                                    design, we have a package that's right for
                                    you.
                                  </p>
                                  <a
                                    className="btnstarts startspackfr"
                                    href="javascript:;"
                                    title=""
                                  >
                                    Starting from
                                    <span className="montfont">£399</span>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-web.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="web_portfolio"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-port"></i>
                                <span>Website Portfolio</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    We enrich the most prestigious names as our
                                    satisfied clientele.
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Photography{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Fashion{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Information & Technology
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        E-Commerce{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-web.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <Link to="/Review" title="">
                                <i className="sprite iconlogo-review"></i>
                                <span>Reviews</span>
                              </Link>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Read the immense appreciation we receive
                                    from our customers.
                                  </p>
                                  <a className="btnstarts" href="#" title="">
                                    Read Client Reviews
                                    <i
                                      className="fa fa-caret-right"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-web.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="parenturl">
                      <Link to="/Nft_design">NFT-Design </Link>
                    </li>
                    <li className="parenturl dropparent">
                      <a href="#" title="">
                        Animation
                        <i
                          className="fa fa-angle-down fa-6"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <div className="dropdown">
                        <div className="lstnavig">
                          <ul className="liststylss anim-drop">
                            <li className="always-active active">
                              <Link to="/Animation_design">
                                <i className="sprite iconlogo-design"></i>
                                <span>Animation Design</span>
                              </Link>
                              <div className="innerdropdowns active-permenent">
                                <div className="listdiscret">
                                  <p>
                                    Get an interactive animated video for your
                                    brand.
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a href="#" title="">
                                        2D Character Animation
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        2D Graphic Animation{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Interactive 3D Animation{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Whiteboard Animation
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Typographic Animation
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Explainer <br />
                                        Videos
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-animation.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="animation_pricing"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-pack"></i>
                                <span>Animation Packages</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    No matter what you're looking for in an
                                    animated video, we have a package that's
                                    right for you.
                                  </p>
                                  <a
                                    className="btnstarts startspackfr"
                                    href="#"
                                    title=""
                                  >
                                    Starting from
                                    <span className="montfont">£499</span>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-animation.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="animdropsPort"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-port"></i>
                                <span>Animation Portfolio</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    We enrich the most prestigious names as our
                                    satisfied clientele.
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Photography{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Fashion{" "}
                                      </a>
                                    </li>

                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Information & Technology
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        E-Commerce{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-animation.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <Link to="/Review">
                                <i className="sprite iconlogo-review"></i>
                                <span>Reviews</span>
                              </Link>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Read the immense appreciation we receive
                                    from our customers.
                                  </p>
                                  <a className="btnstarts" href="#" title="">
                                    Read Client Reviews
                                    <i
                                      className="fa fa-caret-right"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-animation.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="parenturl dropparent">
                      <a href="#" title="">
                        Branding
                        <i
                          className="fa fa-angle-down fa-6"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <div className="dropdown">
                        <div className="lstnavig">
                          <ul className="liststylss">
                            <li className="always-active active">
                              <Link to="/Branding_design">
                                <i className="sprite iconlogo-design"></i>
                                <span>Branding Design</span>
                              </Link>
                              <div className="innerdropdowns active-permenent">
                                <div className="listdiscret">
                                  <p>
                                    Get complete branding solutions for your
                                    brand.
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a href="#" title="">
                                        Brochures{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Banners{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Stationery{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="">
                                        Packaging{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-branding.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="packdropsbrand"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-pack"></i>
                                <span>Branding Packages</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    No matter what you're looking for in Logo
                                    Design Services, we have a package that's
                                    right for you.{" "}
                                  </p>
                                  <a
                                    className="btnstarts startspackfr"
                                    href="#"
                                    title=""
                                  >
                                    Starting from
                                    <span className="montfont">£249</span>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-branding.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <ScrollLink
                                to="branding_portfolio"
                                spy={true}
                                smooth={true}
                                offset={50}
                                duration={500}>
                                <i className="sprite iconlogo-port"></i>
                                <span>Branding Portfolio</span>
                              </ScrollLink>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Exclusive brochures for enhanced
                                    advertising.{" "}
                                  </p>
                                  <ul className="secondinner-navs">
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Leaflet{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Bifold{" "}
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="no-src"
                                        href="javascript:;"
                                        title=""
                                      >
                                        Trifold{" "}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-branding.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                            <li>
                              <Link to="/Review">
                                <i className="sprite iconlogo-review"></i>
                                <span>Reviews</span>
                              </Link>
                              <div className="innerdropdowns">
                                <div className="listdiscret">
                                  <p>
                                    Read the immense appreciation we receive
                                    from our customers.
                                  </p>
                                  <a className="btnstarts" href="#" title="">
                                    Read Client Reviews
                                    <i
                                      className="fa fa-caret-right"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>
                                <div className="listimgs">
                                  <img src="images/drop-branding.jpg" alt="" />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="parenturl">
                      <Link to="/Packages" title="">
                        Packages
                      </Link>
                    </li>
                    <li className="parenturl">
                      <Link to="/Portfoli" title="">
                        Portfolio
                      </Link>
                    </li>
                    <li className="parenturl">
                      <Link to="/About">About Us </Link>
                    </li>
                    <li className="parenturl">
                      <Link to="/Contact_main" title="">
                        Contact Us
                      </Link>
                    </li>
                  
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header> */}
    </>
  );
}
